import { Moment } from 'moment';

import { Employee } from './Employee';
import { make, makeArray, makeMoment, makeUnix } from './Model';
import { ProgramTaskBase } from './ProgramTaskBase';

export class ProgramTask extends ProgramTaskBase {
  lastAppointmentDate?: Moment;

  lastAppointmentType = '';

  lastCCMDate?: Moment;

  lastCCMReason = '';

  nextAppointmentDate?: Moment;

  nextAppointmentType = '';

  children?: ProgramTask[];

  statusUpdatedAt?: Moment;

  statusUpdatedBy?: Employee;

  constructor(obj: any) {
    super({
      ...obj,
      id: obj.taskId,
      name: obj.taskName,
    });
    this.children = makeArray(obj.children, ProgramTask);
    this.lastAppointmentDate = makeMoment(obj.lastAppointmentDate);
    this.lastAppointmentType = obj.lastAppointmentType;
    this.lastCCMDate = makeMoment(obj.lastCCMDate);
    this.lastCCMReason = obj.lastCCMReason;
    this.nextAppointmentDate = makeMoment(obj.nextAppointmentDate);
    this.nextAppointmentType = obj.nextAppointmentType;
    this.statusUpdatedAt = makeUnix(obj.statusUpdatedAt);
    this.statusUpdatedBy = make(obj.statusUpdatedBy, Employee);
  }
}

export default ProgramTask;
